module.exports = __webpack_public_path__ + "img/img_3.e2d15627.jpg";